"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieSettingsModal = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const circleCloseIcon_svg_1 = __importDefault(require("../../../../assets/icons/circleCloseIcon.svg"));
const cookieManager_1 = require("../../../../utils/cookieManager");
const Toggle_1 = require("../../../atoms/Toggle/Toggle");
const S = __importStar(require("./CookieSettingsModal.style"));
const CookieSettingsModal = ({ isOpen, onClose, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [preferences, setPreferences] = (0, react_1.useState)({
        necessary: true,
        analytics: false,
        marketing: false,
        preferences: false,
    });
    // Load existing preferences when modal opens
    (0, react_1.useEffect)(() => {
        if (isOpen) {
            const savedPreferences = cookieManager_1.CookieManager.loadPreferences();
            setPreferences(savedPreferences);
        }
    }, [isOpen]);
    const handlePreferenceChange = (key, value) => {
        const newPreferences = Object.assign(Object.assign({}, preferences), { [key]: value });
        setPreferences(newPreferences);
        // Apply the changes immediately
        cookieManager_1.CookieManager.updatePreference(key, value);
    };
    const handleSave = () => {
        cookieManager_1.CookieManager.savePreferences(preferences);
        onClose();
    };
    const handleAcceptAll = () => {
        cookieManager_1.CookieManager.enableAll();
        setPreferences({
            necessary: true,
            analytics: true,
            marketing: true,
            preferences: true,
        });
        onClose();
    };
    const handleRejectAll = () => {
        cookieManager_1.CookieManager.disableNonNecessary();
        setPreferences({
            necessary: true,
            analytics: false,
            marketing: false,
            preferences: false,
        });
        onClose();
    };
    return (react_1.default.createElement(S.CookieSettingsModal, { open: isOpen, modal: true, nested: true, onClose: onClose, closeOnDocumentClick: true },
        react_1.default.createElement(S.ModalContent, null,
            react_1.default.createElement(S.Header, null,
                react_1.default.createElement(S.Title, null, t("cookieSettings.title")),
                react_1.default.createElement(S.CloseButton, { onClick: onClose },
                    react_1.default.createElement("img", { src: circleCloseIcon_svg_1.default, alt: t("navbar.altClose") }))),
            react_1.default.createElement(S.Description, null, t("cookieBanner.description")),
            react_1.default.createElement(S.PreferencesContainer, null,
                react_1.default.createElement(S.PreferenceItem, null,
                    react_1.default.createElement(S.PreferenceInfo, null,
                        react_1.default.createElement(S.PreferenceTitle, null, t("cookieSettings.necessary.title")),
                        react_1.default.createElement(S.PreferenceDescription, null, t("cookieSettings.necessary.description"))),
                    react_1.default.createElement(Toggle_1.Toggle, { isChecked: preferences.necessary, onChange: () => { }, variant: "toggle", noLabel: true })),
                react_1.default.createElement(S.PreferenceItem, null,
                    react_1.default.createElement(S.PreferenceInfo, null,
                        react_1.default.createElement(S.PreferenceTitle, null, t("cookieSettings.analytics.title")),
                        react_1.default.createElement(S.PreferenceDescription, null, t("cookieSettings.analytics.description"))),
                    react_1.default.createElement(Toggle_1.Toggle, { isChecked: preferences.analytics, onChange: (value) => handlePreferenceChange("analytics", value), variant: "toggle", noLabel: true })),
                react_1.default.createElement(S.PreferenceItem, null,
                    react_1.default.createElement(S.PreferenceInfo, null,
                        react_1.default.createElement(S.PreferenceTitle, null, t("cookieSettings.marketing.title")),
                        react_1.default.createElement(S.PreferenceDescription, null, t("cookieSettings.marketing.description"))),
                    react_1.default.createElement(Toggle_1.Toggle, { isChecked: preferences.marketing, onChange: (value) => handlePreferenceChange("marketing", value), variant: "toggle", noLabel: true })),
                react_1.default.createElement(S.PreferenceItem, null,
                    react_1.default.createElement(S.PreferenceInfo, null,
                        react_1.default.createElement(S.PreferenceTitle, null, t("cookieSettings.preferences.title")),
                        react_1.default.createElement(S.PreferenceDescription, null, t("cookieSettings.preferences.description"))),
                    react_1.default.createElement(Toggle_1.Toggle, { isChecked: preferences.preferences, onChange: (value) => handlePreferenceChange("preferences", value), variant: "toggle", noLabel: true }))),
            react_1.default.createElement(S.ActionsContainer, null,
                react_1.default.createElement(S.AcceptAllButton, { onClick: handleAcceptAll }, t("cookieSettings.acceptAll")),
                react_1.default.createElement(S.RejectAllButton, { onClick: handleRejectAll }, t("cookieSettings.rejectAll")),
                react_1.default.createElement(S.SaveButton, { onClick: handleSave }, t("cookieSettings.save"))))));
};
exports.CookieSettingsModal = CookieSettingsModal;
